import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";


export const LocationStyle = StyleSheet.create({
    flex: {
        flex: 1,
    },
    buttonFont: {
        fontSize: fontSize.errorFontSize, fontFamily: appFonts.bold
    },
    buttonStyle: {
        width: 100,
        borderRadius: 7,
        backgroundColor: appColors.light,
        borderColor: appColors.primary
    },
    titleStyle: {
        color: appColors.primary,
        fontFamily: appFonts.bold,
        fontSize: fontSize.mediumFontSize
    },
    searchView: {
        flexDirection: 'row',
        marginTop: 10,
        marginHorizontal: 7
    },
    searchInputContainer: {
        backgroundColor: appColors.light
    },
    formButtonStyle: {
        borderRadius: 7,
        backgroundColor: appColors.light,
        borderWidth: 1,
        borderColor: appColors.primary,
    },
    formSaveButton: {
        borderRadius: 7,
        backgroundColor: appColors.primary,
        borderWidth: 1,
        borderColor: appColors.primary,
    },
    formButtonTitle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallFontSize
    },
    buttonTitle: {
        color: appColors.primary,
        fontFamily: appFonts.bold,
        fontSize: fontSize.mediumFontSize
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    actionIconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 15
    },
    cardContainer: {
        flex: 1,
        borderRadius: 8,
        marginBottom: 5,
        borderColor: 'transparent',
        elevation: 0
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize,
        paddingTop: 3
    },
    badgeContainer: {
        position: "absolute",
        right: -7,
        top: -7
    },
    filterContainer: {
        marginVertical: 10,
        marginHorizontal: 15,
        borderRadius: 16
    },
    filterHeaderStyle: {
        flexDirection: 'row',
        marginVertical: 5,
        justifyContent: 'flex-end'
    },
    filterFooterStyle: {
        flexDirection: 'row',
        marginVertical: 5,
        marginHorizontal: 10,
        justifyContent: "space-between",
        alignSelf: 'flex-end',
        zIndex: -1
    },
    headerView: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    badgeStyle: {
        width: 90,
        borderRadius: 15
    },
    badgeTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.light,
    },
    badgeText: {
        fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, color: appColors.light
    },
    containerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
    },
    badgeContainerStyle: { justifyContent: 'center', alignSelf: 'flex-start', marginBottom: 7 },
    bodyView: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    loader: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    floatIcon: {
        position: "absolute",
        backgroundColor: appColors.primary,
        width: 60,
        height: 60,
        borderRadius: 32,
        top: '90%',
        left: '80%',
        justifyContent: 'center'
    },
    filterPopoverStyle: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 10,
        backgroundColor: appColors.lightBackgroundColor,
        marginHorizontal: 5,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: appColors.lightGrey
    }

})
